import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { Task } from "./task-tracker.entities";
import { RenderDateYMD } from "../../../shared/scripts/table-functions";
import { Unique } from "../../../shared/scripts/array-functions";
import { IFilter } from "../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDropdownValues, InitializeFilterDropdown } from "../../../shared/scripts/filtering/filtering.utilities";


export class TaskTrackerDataTable implements IFilter {

    tasks: Task[];
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;
    filterOnMilestoneTask: boolean;
    filterOnCriticalTask: boolean;
    filterOnMostCurrentTask: boolean = true; //always?
    filterOnStudy: boolean;

    constructor(taskList: Task[], showMilestoneTaskFilter: boolean, showCriticalTaskFilter: boolean, showStudyFilter: boolean) {
        this.tasks = taskList;
        this.filterOnMilestoneTask = showMilestoneTaskFilter;
        this.filterOnCriticalTask = showCriticalTaskFilter;
        this.filterOnStudy = showStudyFilter;

        //console.log("mi", this.filterOnMilestoneTask, this.filterOnMilestoneTask == true);
        //console.log("st", this.filterOnStudy, this.filterOnStudy == true);

        //console.log(this.filterOnStudy);

        this.initializeTable();
        this.initializeFilters();
    }
    
    initializeFilters(): void {
        InitializeFilterDropdown('#category-dropdown', Unique(this.tasks.map((task: Task) => task.TaskCategory), true), this);
        InitializeFilterDropdown('#status-dropdown', Unique(this.tasks.map((task: Task) => task.Status), true), this);

        if (this.filterOnMilestoneTask) {
            InitializeFilterDropdown('#milestone-task-dropdown', Unique(this.tasks.map((task: Task) => task.DisplayMilestoneTask), true), this);
        }
        if (this.filterOnCriticalTask) {
            InitializeFilterDropdown('#critical-task-dropdown', Unique(this.tasks.map((task: Task) => task.DisplayCriticalTask), true), this);
        }
        if (this.filterOnStudy) {
            InitializeFilterDropdown('#study-dropdown', Unique(this.tasks.map((task: Task) => task.StudyArea), true), this);
        }

        InitializeFilterDropdown('#current-task-dropdown', Unique(this.tasks.map((task: Task) => task.DisplayMostCurrentTask), true), this);
    }

    initializeTable(): void {

        let fixedColumns: number = 2;
        let sortColumn: number = 11;
        let columns: any[] = [
            { data: "TaskCategory", title: "Category", className: "category text-left font-size12 nowrap", width: '110px' },
            { data: { _: "DisplayName", sort: "Name" }, title: "Name", className: "text-left font-size12", width: '180px' },
            { data: "VersionLabel", title: "Version", className: "version text-left font-size12 nowrap" },
            { data: "Status", title: "Status", className: "status text-left font-size12 nowrap" },
            { data: "DisplayMilestoneTask", title: "Is Milestone<br>Task", className: "milestone-task text-center font-size12 nowrap" },
            { data: "DisplayCriticalTask", title: "Is Critical<br>Task", className: "milestone-task text-center font-size12 nowrap" },
            //{ data: "PlannedStartDate", title: "Start Date<br>(Planned)", className: "start-dates text-center font-size12", width: '100px', render: RenderDateYMD },
            { data: "ActualStartDate", title: "Start Date<br>(Actual)", className: "start-dates text-center font-size12", width: '100px', render: RenderDateYMD },
            { data: "PlannedEndDate", title: "End Date<br>(Planned)", className: "end-dates text-center font-size12", width: '100px', render: RenderDateYMD },
            { data: "ActualEndDate", title: "End Date<br>(Actual)", className: "end-dates text-center font-size12", width: '100px', render: RenderDateYMD },
            { data: { _: "DisplayCompletionCriteria", sort: "CompletionCriteria" }, title: "<span class='nowrap'>Completion Criteria</span>", className: "completion text-left font-size12" },
            { data: { _: "DisplayComments", sort: "Comments" }, title: "Comments", className: "comments text-left font-size12", width: '180px' },
            { data: { _: "DisplayStaff", sort: "StaffPipeSeparated" }, title: "Staff", className: "staff text-left font-size12" },
            { data: "ModifiedDate", title: "Modified Date", className: "modified-date text-center font-size12", width: '100px', render: RenderDateYMD },
            { data: { _: "DisplayFiles", sort: "FileNames[0]" }, title: "<span class='nowrap'>File Access</span>", className: "files text-left font-size12" },
            { data: "SortOrder", title: "SortOrder", visible: false },
        ];

        if (this.filterOnStudy) {
            fixedColumns = 3;
            sortColumn = 12;
            columns.unshift({ data: "StudyArea", title: "Study", className: "category text-left font-size12 nowrap", width: '80px' });
        }

        this.dataTable = $('#tasks-table').DataTable({
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: fixedColumns
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [[sortColumn, 'asc']],
            data: this.tasks
        });

        $(".top-controls").addClass('row mx-0');

        $(".column-select").addClass('col-12 col-md-3 px-0');
        $(".column-select").empty().html('<div id="column-select"></div>');

        $(".search-bar").addClass('col-12 col-md-3');

        $(".spacer").addClass('col-12 col-md-3'); 0
        $(".count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"tasks-found-count\"></span></div>');
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController('tasks-table', 'column-select', [
            new TableColumnGroup("Version", true, [], "version"),
            new TableColumnGroup("Status", true, [], "status"),
            new TableColumnGroup("Task Type", false, [], "milestone-task"),
            new TableColumnGroup("Start Date", false, [], "start-dates"),
            new TableColumnGroup("End Dates", true, [], "end-dates"),
            new TableColumnGroup("Completion Criteria", false, [], "completion"),
            new TableColumnGroup("Comments", true, [], "comments"),
            new TableColumnGroup("Staff", false, [], "staff"),
            new TableColumnGroup("Modified Date", true, [], "modified-date"),
            new TableColumnGroup("File Access", true, [], "files"),
        ]);

        $('#tasks-table').on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(this.tasks.length);
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#tasks-found-count').text("No Tasks Found"); break;
            case 1: $('#tasks-found-count').text("1 Task Found"); break;
            default: $('#tasks-found-count').text(count + " Tasks Found");
        }
    }

    refresh(): void {

        ['#category-dropdown', '#status-dropdown'].forEach((id: string) => $(id).selectpicker("refresh"));
        if (this.filterOnMilestoneTask) {
            $('#milestone-task-dropdown').selectpicker("refresh");
        }
        if (this.filterOnCriticalTask) {
            $('#critical-task-dropdown').selectpicker("refresh");
        }

        this.dataTable.columns.adjust();
        this.tableColumnController.refresh();
    }

    triggerFilter(): void {

        let matchingTasks: Task[] = [];

        let taskMatches: boolean;
        this.tasks.forEach((task: Task) => {

            taskMatches = true; //must match all filters

            if (!task.matchesFilter(GetSelectedDropdownValues('#category-dropdown'), GetSelectedDropdownValues('#status-dropdown'), (this.filterOnMilestoneTask) ? GetSelectedDropdownValues('#milestone-task-dropdown') : undefined, (this.filterOnCriticalTask) ? GetSelectedDropdownValues('#critical-task-dropdown') : undefined, (this.filterOnMostCurrentTask) ? GetSelectedDropdownValues('#current-task-dropdown') : undefined)) {
                taskMatches = false;
            }

            if (taskMatches) { matchingTasks.push(task); }
        });

        this.updateTable(matchingTasks);
    }

    updateTable(matchingTasks: Task[]): void {

        this.dataTable.clear();
        this.dataTable.rows.add(matchingTasks).draw();
        this.setCountFoundLabel(matchingTasks.length);
    }
}